// removed by extract-text-webpack-plugin
module.exports = {"event-wrapper":"event-list__event-wrapper__34Wbg","event-header":"event-list__event-header__2kPLU","event-item":"event-list__event-item__2_9Sp","event-item-checked":"event-list__event-item-checked__JmTsj","event-name":"event-list__event-name__Vahd1","event-time":"event-list__event-time__1xLlv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/time-poll/TimePollContainer/SignUp/CreateSignUp/FirstStep/EventList/event-list.scss
// module id = 1782
// module chunks = 1